import { Button, Icon } from '@/components/ui';
import { useDispatch, useSelector } from 'react-redux';

import './girlMap.scss';
import { setStoriesMap } from '@/stores/slices/popupSlice';
import { getUserCurrentCity } from '@/stores/slices/userSlice';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useMemo } from 'react';
import { useFilterLogicContext } from '../filter/FilterLogicProvider';

const GirlMap = () => {
	const dispatch = useDispatch();
	const { params } = useParams();
	const { t } = useTranslation('translation');
	const FILTER = useFilterLogicContext();

	const currentCity = useSelector(getUserCurrentCity);

	const texts = useMemo(() => {
		let postTitle = t('h3main', {
			City: currentCity.title ? currentCity.title : '',
		});
		let postFindnear = t('findnear')?.replace(
			/%([^%]+)%/g,
			currentCity.title,
		);

		if (params?.includes('massage')) {
			postTitle = t('h3massage');
			postFindnear = t('massagenear');
		}

		return { postTitle, postFindnear };
	}, [params, currentCity, t]);

	return (
		<section
			className={'girl-map__container'}
			id="models-map"
		>
			<div className="girl-map__inner">
				<div className={'girl-map__content'}>
					<h2 className="mb-32">
						{!FILTER.isFilterEmpty
							? texts.postTitle
							: t('matching')}
					</h2>
					<Button
						size={'l'}
						clazz={`button--green-tp`}
						onClick={() => {
							dispatch(setStoriesMap(true));
						}}
					>
						{t('onmap')}
						<Icon
							size={'l'}
							spritePath={'map'}
						/>
					</Button>
					<p className="p2 mt-32 mb-0">{texts.postFindnear}</p>
				</div>
			</div>
		</section>
	);
};

export default GirlMap;
